/* unplugin-vue-components disabled */import script from "./YTabs.vue?vue&type=script&setup=true&lang=tsx"
export * from "./YTabs.vue?vue&type=script&setup=true&lang=tsx"

const cssModules = {}
import style0 from "./YTabs.vue?vue&type=style&index=0&id=0c7755ca&module=css&lang=postcss"
cssModules["css"] = style0

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__